<ion-text *ngIf="control.errors && (control.dirty || control.touched)">
  {{ errorPrefix + getFirstError(control.errors) | uppercase | translate: getErrorAdditionalInfo(control.errors) }}
</ion-text>